export default {
  pendingTasksCount(todoList) {
    if (todoList == null || typeof(todoList) === "undefined") return 0;
    return todoList.filter((todo) => !todo.checked).length;
  },
  /** 默认开启；云端/旧配置缺 key 时按 true 处理 */
  shouldMoveCompletedToBottom(config) {
    return !config || config.moveCompletedTaskToBottom !== false;
  },
  /**
   * 稳定分区：未完成在前、已完成在后，组内相对顺序不变。
   * 勾选/取消/新增后恢复不变量；拖拽后也分区，跨区落点会吸回对应区，组内顺序保留。
   */
  partitionCompletedToBottom(toDoList) {
    if (!toDoList || !toDoList.length) return toDoList;
    const pending = [];
    const done = [];
    for (let i = 0; i < toDoList.length; i++) {
      if (toDoList[i].checked) done.push(toDoList[i]);
      else pending.push(toDoList[i]);
    }
    toDoList.splice(0, toDoList.length, ...pending, ...done);
    return toDoList;
  },
  /** 拖到「列表末尾」：未完成进未完成区末尾，已完成进全表末尾 */
  appendPreservingSections(toDoList, toDo, moveCompleted) {
    if (!toDoList) return toDoList;
    if (moveCompleted && !toDo.checked) {
      const firstChecked = toDoList.findIndex((t) => t.checked);
      const index = firstChecked < 0 ? toDoList.length : firstChecked;
      toDoList.splice(index, 0, toDo);
    } else {
      toDoList.push(toDo);
    }
    return toDoList;
  },
  applyListOrder(toDoList, config) {
    if (!toDoList) return toDoList;
    if (config && config.autoReorderTasks) {
      return this.reorderTasksList(toDoList);
    }
    if (this.shouldMoveCompletedToBottom(config)) {
      return this.partitionCompletedToBottom(toDoList);
    }
    return toDoList;
  },
  reorderTasksList(toDoList) {
    var array = toDoList;
    array.sort(function (a, b) {
      if (b.checked != a.checked) {
        if (b.checked) return -1;
        if (a.checked) return 1;
      }
      if (b.time != a.time) {
        if (b.time == null) return -1;
        if (a.time == null) return 1;
      }
      if (b.time < a.time) return 1;
      if (b.time > a.time) return -1;
    });
    return array;
  },
};
